import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input, Label } from "../../../components/base";
import { FieldDescription } from "../FieldDescription";
export const NumberField = ({ field, value, disabled, error, onChange, }) => {
    const stringValue = value !== undefined && value !== null ? String(value) : "";
    return (_jsxs("div", { className: "space-y-1", children: [_jsxs(Label, { className: "text-xs", children: [field.question, " ", field.required && _jsx("span", { className: "text-red-500", children: "*" })] }), _jsx(FieldDescription, { ...field }), _jsx(Input, { type: "number", value: stringValue, onChange: (e) => onChange?.(e.target.value), placeholder: field.placeholder, disabled: disabled, min: field.min, max: field.max, step: field.step ?? "any", className: error ? "border-red-500 focus-visible:ring-red-500" : undefined }), error && _jsx("p", { className: "text-xs text-red-500", children: error })] }));
};
export const validateNumberField = (field, value, t) => {
    const str = value === undefined || value === null ? "" : String(value);
    if (field.required && str.trim() === "") {
        return t("form.validation.required");
    }
    if (str.trim() === "")
        return undefined;
    const num = Number(str);
    if (Number.isNaN(num)) {
        return t("form.validation.numberInvalid");
    }
    if (typeof field.min === "number" && num < field.min) {
        return t("form.validation.numberMin", { min: field.min });
    }
    if (typeof field.max === "number" && num > field.max) {
        return t("form.validation.numberMax", { max: field.max });
    }
    return undefined;
};
//# sourceMappingURL=NumberField.js.map